import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerServiceWorker } from './lib/pwa';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App/></React.StrictMode>);

// Makes the app installable and able to open without a network connection.
// A new build raises an in-app banner rather than reloading itself — a POS
// must not refresh mid-order. See src/lib/pwa.js.
registerServiceWorker({
  onUpdateReady: () => window.dispatchEvent(new Event('agtpos:update-ready')),
});
